module.exports = __webpack_public_path__ + "img/scadaDesigner_.png";